<nav [ngClass]="{
    'tw-bg-transparent tw-shadow-none': !scrolled,
    'tw-bg-black/80 tw-shadow-md tw-backdrop-blur': scrolled
  }" class="tw-fixed tw-top-0 tw-w-full tw-z-50 tw-transition-all tw-duration-300 tw-py-3 tw-px-4 sm:tw-px-6">
  <div class="tw-flex tw-items-center tw-justify-between tw-max-w-7xl tw-mx-auto">
    <!-- Logo -->
    <div class="tw-items-center tw-hidden md:tw-flex tw-gap-2">
      <a href="/">
        <img src="assets/images/logo.png" alt="Logo" class="tw-h-8 tw-w-auto" />

      </a>
    </div>

    <!-- Botón hamburguesa -->
    <button
      class="md:tw-hidden tw-relative tw-z-50 tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-text-[#F67011] focus:tw-outline-none"
      (click)="toggleMenu()" aria-label="Menú">
      <span [ngClass]="{
          'tw-translate-y-0 tw-rotate-45': menuOpen,
          'tw-translate-y-2': !menuOpen
        }" class="tw-absolute tw-w-6 tw-h-0.5 tw-bg-current tw-transition-all tw-duration-300 tw-ease-in-out"></span>
      <span [ngClass]="{ 'tw-opacity-0': menuOpen }"
        class="tw-absolute tw-w-6 tw-h-0.5 tw-bg-current tw-transition-all tw-duration-300 tw-ease-in-out"></span>
      <span [ngClass]="{
          'tw-translate-y-0 -tw-rotate-45': menuOpen,
          '-tw-translate-y-2': !menuOpen
        }" class="tw-absolute tw-w-6 tw-h-0.5 tw-bg-current tw-transition-all tw-duration-300 tw-ease-in-out"></span>
    </button>

    <!-- Menú Desktop -->
    <div class="tw-hidden md:tw-flex tw-items-center tw-gap-10">
      <div class="tw-flex tw-gap-6 tw-text-white">
        <a href="#"
          class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">
          Inicio
          <span
            class="tw-absolute tw-bottom-0 tw-left-1/2 tw-h-0.5 tw-bg-[#F67011] tw-origin-center group-hover:tw-w-full tw-w-0 tw-transition-all tw-duration-300 -tw-translate-x-1/2"></span>
        </a>
        <a href="/servicios"
          class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">Servicios
          <span
            class="tw-absolute tw-bottom-0 tw-left-1/2 tw-h-0.5 tw-bg-[#F67011] tw-origin-center group-hover:tw-w-full tw-w-0 tw-transition-all tw-duration-300 -tw-translate-x-1/2"></span>
        </a>
        <a href="/nosotros"
          class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">Nosotros

          <span
            class="tw-absolute tw-bottom-0 tw-left-1/2 tw-h-0.5 tw-bg-[#F67011] tw-origin-center group-hover:tw-w-full tw-w-0 tw-transition-all tw-duration-300 -tw-translate-x-1/2"></span>
        </a>
        <a href="/contacto"
          class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">Contacto
          <span
            class="tw-absolute tw-bottom-0 tw-left-1/2 tw-h-0.5 tw-bg-[#F67011] tw-origin-center group-hover:tw-w-full tw-w-0 tw-transition-all tw-duration-300 -tw-translate-x-1/2"></span>
        </a>
      </div>

      <div class="tw-flex tw-gap-3">
        <!-- <a href="/cobertura"
          class="tw-decoration-transparent tw-bg-orange-500 tw-font-semibold hover:tw-bg-orange-600 tw-text-white tw-px-4 tw-py-2 tw-rounded-full tw-text-sm">Cobertura</a> -->


        <a target="_blank"
          href="https://api.whatsapp.com/send/?phone=582813169200&text=Hola%2C+me+gustar%C3%ADa+solicitar+un+soporte.&type=phone_number&app_absent=0"
          class="tw-decoration-transparent tw-bg-[#1B16E4] tw-font-semibold hover:tw-bg-[#0000BC] tw-text-white tw-px-4 tw-py-2 tw-rounded-full tw-text-sm">Soporte</a>


      </div>
    </div>
  </div>

  <!-- Menú Móvil -->
  <div *ngIf="menuOpen"
    class="md:tw-hidden  tw-bg-black tw-rounded-xl tw-mt-3 tw-px-4 tw-py-6 tw-space-y-4 tw-backdrop-blur-sm tw-animate-fade-in tw-text-white tw-shadow-lg tw-border-[1px] tw-border-gray-100">

    <div class="tw-flex tw-justify-center tw-items-center">
      <img src="assets/images/logo.png" alt="Logo" class="tw-h-8 tw-w-auto" />
    </div>

    <div class="tw-px-2 tw-order-1 md:tw-order-2 relative tw-mt-8 md:tw-mt-0 tw-flex tw-justify-center">
      <img src="assets/elipsis/orange.svg" alt=""
        class="tw-absolute tw-right-[0px] tw-top-[-10px] lg:tw-top-[-10px] lg:tw-right-[10px] tw-opacity-80 tw-blur-md" />
      <img src="assets/elipsis/blue.svg" alt=""
        class="tw-absolute tw-top-[-5px] tw-right-[0px] lg:tw-top-[-10px] lg:right-[10px] tw-opacity-80 tw-blur-md" />
    </div>


    <div class="tw-flex tw-flex-col tw-space-y-3">
      <a href="#"
        class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">
        Inicio
        <span
          class="tw-absolute tw-bottom-0 tw-left-0 tw-w-0 tw-h-0.5 tw-bg-[#F67011] group-hover:tw-w-[50%] tw-transition-all tw-duration-300"></span>
      </a>
      <a href="/servicios"
        class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">Servicios
        <span
          class="tw-absolute tw-bottom-0 tw-left-0 tw-w-0 tw-h-0.5 tw-bg-[#F67011] group-hover:tw-w-[50%] tw-transition-all tw-duration-300"></span>
      </a>
      <a href="/nosotros"
        class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">Nosotros

        <span
          class="tw-absolute tw-bottom-0 tw-left-0 tw-w-0 tw-h-0.5 tw-bg-[#F67011] group-hover:tw-w-[50%] tw-transition-all tw-duration-300"></span>
      </a>
      <a href="/contacto"
        class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">Contacto

        <span
          class="tw-absolute tw-bottom-0 tw-left-0 tw-w-0 tw-h-0.5 tw-bg-[#F67011] group-hover:tw-w-[50%] tw-transition-all tw-duration-300"></span></a>
      <!-- <a href="/cobertura"
        class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">
        Cobertura
        <span
          class="tw-absolute tw-bottom-0 tw-left-0 tw-w-0 tw-h-0.5 tw-bg-[#F67011] group-hover:tw-w-[50%] tw-transition-all tw-duration-300"></span>
      </a> -->
      <a target="_blank"
        href="https://api.whatsapp.com/send/?phone=582813169200&text=Hola%2C+me+gustar%C3%ADa+solicitar+un+soporte.&type=phone_number&app_absent=0"
        class="tw-relative tw-group tw-decoration-transparent tw-text-white tw-font-medium hover:tw-text-orange-400 tw-transition-colors tw-duration-200 tw-py-2 tw-px-1">Soporte
        <span
          class="tw-absolute tw-bottom-0 tw-left-0 tw-w-0 tw-h-0.5 tw-bg-[#F67011] group-hover:tw-w-[50%] tw-transition-all tw-duration-300"></span>
      </a>
    </div>
  </div>
</nav>